module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      open: _vm.isNavOpen
    }
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "logo"
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": '/'
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav-icon"
    },
    on: {
      "click": _vm.toggleNav
    }
  }, [_c('span', {
    staticClass: "n1"
  }), _vm._v(" "), _c('span', {
    staticClass: "n2"
  }), _vm._v(" "), _c('span', {
    staticClass: "n3"
  })]), _vm._v(" "), _c('nav', [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": '/work'
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleNav($event)
      }
    }
  }, [_vm._v("Work")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/about'
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleNav($event)
      }
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/contact'
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleNav($event)
      }
    }
  }, [_vm._v("Contact")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Choreographer\u2028 "), _c('span', {
    staticClass: "cardo"
  }, [_vm._v("&")]), _vm._v(" Dancer")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55cbe936"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/front/HeaderFront.vue
// module id = 261
// module chunks = 1